import React, { useState } from "react";
import Header from "../components/header";
import "./pstyle.css";
import translations from "../locals/translation";
import { LuCircleChevronLeft } from "react-icons/lu";
// import { IoIosSearch } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import Swal from "sweetalert2";
import { MdOutlineFileUpload } from "react-icons/md";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import GlobalURL from "../baseUrl";
import { MdDelete } from "react-icons/md";

function AddaAvatar() {
  const ref1 = useRef(null);

  const [ueLoadAvatGal, setUeLoadAvatGal] = useState(false);

  const [uploading, setUploading] = useState(false);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const location = useLocation();
  if (location.state == null || location.state === undefined) {
    // navigate('/dashboard');
  }
  const language = useSelector((state) => state.language.value);

  const [gridStyle, setGridStyle] = useState({
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)",
    gridTemplateRows: `repeat(5, 1fr)`,
    gap: "10px",
  });

  const t = (key) => {
    if (translations[language]) {
      const translation = translations[language][key];
      return translation !== undefined ? translation : key;
    } else {
      return key;
    }
  };

  const [avatar, setAvatar] = useState([]);

  const [selectedImage, setSelectedImage] = useState(null);

  const [selectedImage2, setSelectedImage2] = useState(null);

  const [showAdd, setShowAdd] = useState(false);

  const handleImageInputChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage2(file);
    if (!file) {
      console.error("No file selected");
      return;
    }

    // Display the selected image
    const reader = new FileReader();
    reader.onload = () => {
      setSelectedImage(reader.result);
    };
    reader.readAsDataURL(file);
  };

  async function getAvatarImages() {
    const url = `${GlobalURL}/api/dev/admin/getAvatarImages`;
    const token = localStorage.getItem("token");
    const lang_id = localStorage.getItem("lang");

    const headers = {
      token: token,
      lang_id: lang_id,
      "ngrok-skip-browser-warning": "69420",
    };

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: headers,
      });

      const data = await response.json();
      if (data.status_code !== 200) {
        setLoading(false);
      }

      setAvatar(data.data);
      const numRows = Math.ceil(data.data.length / 5);
      const gridStyle2 = {
        display: "grid",
        gridTemplateColumns: "repeat(5, 1fr)",
        gridTemplateRows: `repeat(${numRows}, 1fr)`,
        gap: "10px",
      };
      setGridStyle(gridStyle2);
      setLoading(false);

      return data;
    } catch (error) {
      setLoading(false);
      console.error("Error:", error);
    }
  }

  async function uploadAvatar() {
    setUploading(true);
    if (!selectedImage2) {
      window.alert(t("Please select an Avatar to upload"));
      setUploading(false);
      return;
    }
    if (
      selectedImage2.type === "jpeg" ||
      selectedImage2.type === "jpg" ||
      selectedImage2.type === "png"
    ) {
      window.alert(
        "Invalid file format. Please upload a file with correct format."
      );
      setLoading(false);
      return;
    }

    const url = `${GlobalURL}/api/dev/admin/uploadAvatarupdated`;
    const lang_id = localStorage.getItem("lang");
    const token = localStorage.getItem("token");

    const headers = {
      lang_id: lang_id,
      token: token,
      "ngrok-skip-browser-warning": "69420",
    };

    const formData = new FormData();
    // formData.append('thumbnail', thumbFile2);
    formData.append("avatar", selectedImage2);

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: formData,
      });

      const data = await response.json();
      if (data.status_code === 200) {
        Swal.fire({
          icon: "success",
          title: t("Uploaded"),
        });
        setUploading(false);
        setUeLoadAvatGal(!ueLoadAvatGal);
        setShowAdd(false);
        setSelectedImage("");
        setSelectedImage2("");
      }
      if (data.status_code !== 200) {
        Swal.fire({ title: data.message, icon: "warning" });

        setUploading(false);
        setUeLoadAvatGal(!ueLoadAvatGal);
      }
    } catch (error) {
      console.error("Error:", error.message);
    }
  }

  const handleInput1Click = () => {
    ref1.current.click();
  };

  const deleteAvatarPermission = (id) => {
    Swal.fire({
      title: t("Are you sure?"),
      text: t("You won't be able to revert this!"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#290a0e",
      cancelButtonColor: "#290a0e",
      confirmButtonText: t("Yes"),
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteAvatar(id);
      }
    });
  };

  async function deleteAvatar(id) {
    Swal.fire({
      title: t("Deleting..."),
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    const url = `${GlobalURL}/api/dev/admin/deleteAvatar`;
    const token = localStorage.getItem("token");
    const lang_id = localStorage.getItem("lang");
    const avatar_id = id;

    const headers = {
      lang_id: lang_id,
      token: token,
      "Content-Type": "application/json",
    };

    const body = JSON.stringify({ avatar_id });

    try {
      const response = await fetch(url, {
        method: "POST",
        headers,
        body,
      });

      const responseData = await response.json();

      if (responseData.status_code === 200) {
        setUeLoadAvatGal(!ueLoadAvatGal);
        Swal.close();
      } else {
        console.error("Failed to delete avatar:", responseData);
        Swal.close();
      }
    } catch (error) {
      Swal.close();
      console.error("An error occurred:", error);
    }
  }

  useEffect(() => {
    getAvatarImages();
  }, [ueLoadAvatGal]);

  useEffect(() => {
    getAvatarImages();
  }, []);

  return (
    <React.Fragment>
      <Header />
      <div className="dashboard-Container">
        <div className="body-container-dashboard">
          <div className="login-heading">
            <h1 style={{ marginTop: "0px" }}>{t("Avatar Gallery")}</h1>
            <h5>
              {t(
                "Below is the list of default avatars along with those which are uploaded by the admin."
              )}
            </h5>
          </div>

          <div className="table-content">
            <div className="input-with-search">
              <div className="search-backgallery">
                <LuCircleChevronLeft
                  fill="none"
                  className="back-button"
                  onClick={() => navigate(-1)}
                />
                <div className="input-with-search">
                  <Button
                    variant="success"
                    className="buttons"
                    style={{
                      background: "rgba(67, 17, 23, 1)",
                      outline: "none",
                    }}
                    onClick={() => {
                      setShowAdd(true);
                    }}
                  >
                    {t("Add Avatar")}
                  </Button>
                </div>
              </div>
            </div>
            {
              <div className="avatar-tab">
                {loading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div className="loading-spinner"></div>
                    <p className="logging-heading">{t("Loading")}</p>
                  </div>
                ) : (
                  <div className="avatar-grid" style={gridStyle}>
                    {avatar.map((item, index) => (
                      <div className="delete-with-img" key={index}>
                        <MdDelete
                          onClick={() => {
                            deleteAvatarPermission(item.avatar_id);
                          }}
                          className="delete-icon"
                        />
                        <img src={item.image_url} alt="img" />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            }
          </div>
        </div>
      </div>

      {/* <Footer /> */}

      <Modal
        show={showAdd}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            {t("Add Avatar")}
          </Modal.Title>
          <label
            onClick={() => {
              setShowAdd(false);
              setSelectedImage("");
              setSelectedImage2("");
            }}
          >
            X
          </label>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-body-for-css">
            <div className="input-plus">
              <p>{t("Image")}</p>
              <MdOutlineFileUpload
                className="svg-images"
                onClick={() => {
                  handleInput1Click();
                }}
              />
              <input
                style={{ width: "0px" }}
                className="image-input"
                type="file"
                accept="image/*"
                onChange={handleImageInputChange}
                ref={ref1}
              />
              {selectedImage && (
                <div className="selected-img-from">
                  <img
                    src={selectedImage}
                    alt="Selected"
                    style={{ maxWidth: "100%" }}
                  />
                  <MdDelete
                    onClick={() => {
                      setSelectedImage("");
                      setSelectedImage2("");
                    }}
                    className="delete-icon"
                  />
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <p> {t("# Only JPG, JPEG, and PNG files are allowed!")} </p>
          <Button
            style={{ zIndex: "999" }}
            disabled={uploading}
            onClick={() => {
              uploadAvatar();
            }}
          >
            {uploading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div className="loading-spinner"></div>
              </div>
            ) : (
              t("Upload")
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}

export default AddaAvatar;
